<template>
  <!--  合同详情审批  -->
  <el-container class="audit-style">
    <!--左侧列表-->
    <el-aside width="3.20rem" class="aside-left" :style="{ height: boxHeight }">
      <p class="page-total">
        <span class="tit">签署文件列表</span>
        <span>（共{{ fileList.length }}个）</span>
      </p>
      <div class="aside-left_flex">
        <div class="page-con" :style="{height: leftCSideHeight}">
          <template v-for="(file, i) in fileList">
            <div
              :key="i"
              @click="chooseFile(file, i)"
              :class="checkAct === i ? 'active' : ''"
              class="list"
            >
              <div class="bx">
                <img
                  v-if="fileSuffix(file.fileName) === 'pdf'"
                  src="/images/advancedVersion/pdf.png"
                />
                <img
                  v-if="fileSuffix(file.fileName) === 'wps'"
                  src="/images/advancedVersion/WPS.png"
                />
                <img
                  v-if="fileSuffix(file.fileName) === 'jpg'"
                  src="/images/advancedVersion/JPG.png"
                />
                <img
                  v-if="
                  fileSuffix(file.fileName) === 'doc' ||
                    fileSuffix(file.fileName) === 'docx'
                "
                  src="/images/advancedVersion/word.png"
                />
                <img
                  v-if="
                  fileSuffix(file.fileName) === 'xlsx' ||
                    fileSuffix(file.fileName) === 'xls'
                "
                  src="/images/advancedVersion/xlsx.png"
                />
              </div>
              <p class="title" :title="file.fileName">{{ file.fileName }}</p>
            </div>
          </template>
        </div>
        <div>
          <!--缩略图-->
<!--          <div-->
<!--            v-if="fileImgName"-->
<!--            class="file-img-btn"-->
<!--            @click="fileImgShow = !fileImgShow"-->
<!--          >-->
<!--            {{ fileImgName || "" }}-->
<!--            <strong-->
<!--              class="file-arrow"-->
<!--              :class="fileImgShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"-->
<!--            ></strong>-->
<!--          </div>-->
          <transition name="el-zoom-in-top">
            <div
              class="list-pages"
              :style="{ height: leftCSideHeight }"
            >
              <template v-for="i in contractInfoTemporary.items">
                <div
                  @click="getContractDetailByNum(i)"
                  :class="currentInfo.page === i ? 'active' : ''"
                  :key="i"
                  class="listDetail"
                >
                  <img :src="imgShowFn(i)" />
                  <span>{{ i }}</span>
                </div>
              </template>
            </div>
          </transition>
        </div>
      </div>
    </el-aside>
    <transition name="el-fade-in">
      <div
        class="aside"
        :style="{ height: boxHeight }"
        v-show="drawerShow"
      ></div>
    </transition>
    <transition name="my">
      <div
        class="aside-content"
        :style="{ height: boxHeight }"
        v-show="drawerShow"
      >
        <div class="aside-top">
          <template v-if="tabIndex === 1">
            签署状态
          </template>
          <template v-if="tabIndex === 2">
            仅供参与方查阅，不用于签署（共 {{ this.enclosureList.length }} 份）
          </template>
          <template
            v-if="notShowFlowInfo"
          >
            审批详情
          </template>
          <span class="el-icon-error" @click="closeTabBox"></span>
        </div>
        <div class="aside-box" :style="{ height: mainHeight - 60 + 'px' }">
          <!-- 附件显示 -->
          <div class="enclosure-box" v-if="tabIndex === 2">
            <div
              class="enclosure-item"
              v-for="(item, index) in enclosureList"
              :key="index"
            >
              <!--预览-->
              <div class="li-preview">
                <!--图片和video预览-->
                <span
                  class="el-icon-view"
                  title="预览"
                  v-if="isImg(item) || isVideo(item)"
                  @click="previewVideOrImg(item)"
                ></span>
                <!-- 文档预览-->
                <span
                  class="el-icon-view"
                  title="预览"
                  v-if="isDoc(item)"
                  @click="previewDoc(item)"
                ></span>
                <a :href="downloadAttatchFile(item.file)" target="_blank">
                  <span class="el-icon-download" title="下载"></span>
                </a>
              </div>
              <div class="li-con">
                <div class="t-do">{{ getEnclosureSuffix(item) }}</div>
                <h1 :title="item.file.fileName">{{ item.file.fileName }}</h1>
              </div>
            </div>
            <no-data
              v-if="enclosureList.length === 0"
              text="暂无数据"
              slot="empty"
            />
          </div>
          <!-- 签署详情 -->
          <div class="signingFlow-box" v-if="tabIndex === 1">
            <div class="signingFlow-top">
              <span>签署流程示意图</span>
            </div>
            <div class="signingFlow-tit">
              <img class="photo" src="/images/web/p-default.png" />
              <p>{{ detailInfo.ebqUserName }}</p>
            </div>
            <h4>发起方</h4>
            <div class="arr-down">
              <i class="el-icon-arrow-down"></i>
            </div>
            <div
              class="signingFlow"
              v-if="detailInfo.signInfos && detailInfo.signInfos.length !== 0"
            >
              <div
                class="signingFlow-item"
                :class="detailInfo.orderFlag ? 'orderLi' : ''"
                v-for="(item, index) in detailInfo.signInfos"
                :key="index"
              >
                <div
                  class="signing-flow-tit"
                  v-if="item.hasOwnProperty('fullName')"
                >
                  <img class="photo" src="/images/web/p-default.png" />
                  <el-tooltip effect="light" placement="bottom-end">
                    <div slot="content">
                      名称：{{ item.fullName }} <br />
                      证件号：{{ item.identityCardMask }} <br />
                      接收手机或邮箱：{{ item.mobileMask || item.emailMask }}
                    </div>
                    <p>{{ item.fullName || "请输入签署方名称" }}</p>
                  </el-tooltip>
                </div>
                <div class="signing-flow-tit" v-else>
                  <img class="photo" src="/images/web/p-default.png" />
                  <p>批量签署方</p>
                </div>
                <p>
                  <template v-if="item.signStatus == 1"
                    ><span style="color: #76D0D0">已签署</span></template
                  >
                  <template v-else-if="item.signStatus == 2"
                    ><span style="color: #EC1C1C">已拒绝</span></template
                  >
                  <template v-else
                    ><span style="color: #999999">未签署</span></template
                  >
                </p>
              </div>
            </div>
            <div class="arr-down">
              <i class="el-icon-arrow-down"></i>
            </div>
            <span class="signStatus" :class="'s' + detailInfo.signStatus">{{
              statusText
            }}</span>
            <div class="signingFlow" v-if="detailInfo.signStatus === 2">
              拒签理由：{{ detailInfo.refusedReason || "" }}
            </div>
          </div>
          <!-- 审批详情 -->
          <div class="enclosure-box" v-if="tabIndex === 3">
            <audit-detail v-if="!isInDingTalk" :auditor="auditDetailInfo"></audit-detail>
            <ding-audit-detail v-if="isInDingTalk" :auditor="auditDetailInfo" :applyInfo="detailInfo"></ding-audit-detail>
          </div>
        </div>
      </div>
    </transition>
    <div class="aside-tab" :class="drawerShow ? 'open' : 'close'">
      <div
        class="tab"
        :class="drawerShow && tabIndex !== 1 ? 'black' : ''"
        @click="tabHandleClick(1)"
      >
<!--        <i class="el-icon-circle-plus"></i>-->
        <span class="word">签署状态</span>
        <i
          :class="tabIndex === 1 ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
        ></i>
      </div>
      <div
        class="tab"
        v-if="enclosureList.length > 0"
        :class="drawerShow && tabIndex !== 2 ? 'black' : ''"
        @click="tabHandleClick(2)"
      >
<!--        <i class="el-icon-circle-plus"></i>-->
        <span class="word">附属材料</span>
        <i
          :class="tabIndex === 2 ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
        ></i>
      </div>
      <div
        class="tab"
        v-if="$route.query.approveId"
        :class="drawerShow && tabIndex !== 3 ? 'black' : ''"
        @click="tabHandleClick(3)"
      >
<!--        <i class="el-icon-circle-plus"></i>-->
        <span class="word">审批详情</span>
        <i
          :class="tabIndex === 3 ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
        ></i>
      </div>
    </div>
    <el-main
      ref="contrBody"
      class="main-box"
      :style="{ height: mainHeight + 'px' }"
    >
      <contract-view
        ref="contractView"
        :chapter-list.sync="chapteJson"
        :contract-info.sync="currentInfo"
        :items="contractInfoTemporary.items"
        :page="currentInfo.page"
        :scaleValue.sync="scaleValue"
        :targetId="contractInfoTemporary.targetId"
        :is-detail="true"
        @pre-page="getContractDetailByNum($event)"
        @next-page="getContractDetailByNum($event)"
      />
      <div class="contract-bottom">
        <template
          v-if="
            contractInfoTemporary &&
              contractInfoTemporary.items &&
              contractInfoTemporary.items > 1
          "
        >
          <p
            style="font-weight: bold; text-align: center"
          >{{ currentInfo.page }}/{{ contractInfoTemporary.items }}</p>
          <el-tooltip effect="light" placement="left-start">
            <div slot="content">回到首页</div>
            <span @click="goPageAndFixed(1)" class="arrow-up">
                <img src="../../assets/images/btn-down.png" />
              </span>
          </el-tooltip>
          <el-tooltip effect="light" placement="left">
            <div slot="content">上一页</div>
            <span
              @click="goPageAndFixed(currentInfo.page > 1 ? currentInfo.page - 1 : 1)"
              class="el-icon-arrow-up"
            ></span>
          </el-tooltip>
          <el-tooltip effect="light" placement="left">
            <div slot="content">下一页</div>
            <span
              @click="goPageAndFixed(contractInfoTemporary.items > currentInfo.page ? currentInfo.page + 1 : contractInfoTemporary.items)"
              class="el-icon-arrow-down"
            ></span>
          </el-tooltip>
          <el-tooltip effect="light" placement="left-end">
            <div slot="content">回到尾页</div>
            <span @click="goPageAndFixed(contractInfoTemporary.items)" class="arrow-down">
                <img src="../../assets/images/btn-down.png" />
              </span>
          </el-tooltip>
<!--          <span class="jumpFirst" @click="goPageAndFixed(1)"-->
<!--          ><img src="../../assets/images/btn-down.png"-->
<!--          /></span>-->
<!--          <span class="jumpFirst" @click="goPageAndFixed(1)"-->
<!--          ><img src="../../assets/images/btn-down.png"-->
<!--          /></span>-->
<!--          <span-->
<!--            class="jumpLast"-->
<!--            @click="goPageAndFixed(contractInfoTemporary.items)"-->
<!--            ><img src="../../assets/images/btn-down.png"-->
<!--          /></span>-->
        </template>
      </div>
    </el-main>
    <el-aside width="2.80rem" class="aside-right" :class="'approve-aside'">
      <!--   审查工具   -->
      <!-- 24-06-19 产品通知 因为合同管理第三方问题，功能隐藏 -->
      <!-- <div
        class="box-center"
        style="padding-top: 0;width:80%;margin:0 auto;"
        v-show="
          detailInfo &&
            detailInfo.hideSignAllBtnFlag !== 1 &&
            detailInfo.createType !== 0
        "
      >
        <div class="tl" style="margin: 20px 0 10px 0;font-weight:bold;">
          合同审查工具
        </div>
        <examination-tool
          :defaultTargetFile="detailInfo"
          :checkAct="checkAct"
        />
      </div> -->
      <!--合同更多的详情信息按钮-->
      <div class="bottom-btns" v-if="!isInDingTalk">
        <div class="bottom_textarea">
          <span>审批意见：</span>
          <el-input
            type="textarea"
            rows="5"
            resize="none"
            :autofocus="true"
            size="small"
            :maxlength="100"
            placeholder="请输入审批意见"
            v-model="refuseModel.reason"
          />
        </div>
        <p>
          <el-button
            @click="clickHanldeAuditRefuse(1)"
            type="danger"
            size="small"
            class="btn"
            >同意</el-button
          >
        </p>
        <p>
          <el-button @click="clickHanldeAuditRefuse(2)" size="small" class="btn"
            >拒绝</el-button
          >
        </p>
      </div>
      <!--  刘总要求在待我审合同详情中也加入审批功能 24-07-25 -->
      <div v-if="isInDingTalk">
        <p>
          <el-button
            @click="dingApproval()"
            type="danger"
            size="small"
            class="btn"
            >审批</el-button
          >
        </p>
      </div>
    </el-aside>
    <!--pdf预览-->
    <ViewFilesToDoc
      :visibleShow="visibleShowEnclosureDoc"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
    />
    <!--附件图片video预览显示-->
    <ViewFilesToImg
      :visibleShow="visibleShowEnclosure"
      :isRefresh="isRefresh"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      :imgList="getEnclosureImgList"
      @setViewFilesToImgDialogData="onSetViewFilesToImgDialogData"
    />
  </el-container>
</template>

<script>
import {
  ApiMethods,
  convertDetailToShow,
  tempConvertToContract,
  getFindFileDownload,
  postFindAttatchInfo
} from "@/assets/js/http-serve/http-methods";
import AuditDetail from "../../components/auditDetail/new";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import ContractView from "../../components/contract-view/approve";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import examinationTool from "@/components/signInfo/examination-tool";
import { isInDingTalk } from '@/assets/js/utils/ding-env';
import dingAuditDetail from "@/components/auditDetail/dingNew.vue";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";
import { mapGetters } from "vuex";

export default {
  components: {
    AuditDetail,
    dingAuditDetail,
    ContractView,
    ViewFilesToDoc,
    ViewFilesToImg,
    examinationTool,
  },
  data() {
    return {
      DINGSDK: null,
      isInDingTalk,
      refuseModel: {
        reason: "",
        errorMessage: "",
        wordNumber: 0,
        flowStatus: '',
      },
      auditDetailInfo: null,
      ApiMethods: ApiMethods,
      navTab: 1,
      mainHeight: "1170",
      windowHeight: 0,
      nextLeft: "0px",
      gotoPage: null,
      currentData: 1,
      viewInfo: {},
      detailInfo: {},
      fileInfo: {},
      convertInfo: {},
      contractLoading: true,
      /*903需求*/
      fileList: [],
      boxHeight: "1170px",
      leftCSideHeight: 0,
      checkAct: 0,
      contractInfoTemporary: "",
      drawerShow: false,
      tabIndex: 0,
      enclosurePreviewNumItem: {}, // 当前预览项
      isRefresh: true, // 预览附件时，强制刷新
      // enclosureLoading: false, // 附件弹窗加载时的loading
      // 合同缩放比例
      enclosureList: [], // 附件列表
      chapteJson: [],
      enclosureShow: true,
      visibleShowEnclosure: false,
      visibleShowEnclosureDoc: false,
      currentInfo: { page: 1, url: "" },
      contractList: {},
      // 合同缩放比例
      scaleValue: 100,
      initPage: 0,
      fileImgName: "",
      fileImgShow: true
    };
  },
  async created() {
    this.fetchData();
    this.getEnclosure();
    this.DINGSDK = await this.$DingSDKPromise();
  },
  mounted() {
    this.boxHeight = document.body.clientHeight - 60 + "px";
    let { query } = this.$route;

    this.mainHeight = document.body.clientHeight - 60;
    this.leftCSideHeight =
      document.body.getBoundingClientRect().height - 100 + "px";
    this.clickHanldeAuditDetail();
  },
  watch: {
    "refuseModel.reason": function() {
      this.handleChange();
    }
  },
  computed: {
    ...mapGetters(['currentAuthUser','allAuthUser',]),
    /** 不展示审批详情的逻辑 */
    notShowFlowInfo(){
      /**
       *
       * 6.以上均需区分来源 在saas中查看时  非saas来源的合同（目前钉钉）在存在审批流程时，提示利旧 让用户前往钉钉查看
       */
      const {auditDetailInfo,detailInfo:info,currentAuthUser:curr,allAuthUser:allU} = this;
      const accInfo = allU.accountInfoVO;
      //* 1.个人用户（个人身份下） 在待ta签的合同详情中 需要去除审批详情入口 userType 0 个人 userType 1 企业  【selfSign !=1 && signStatus == 0】
      const notShowPer = curr && curr.userType === 0 && (info&&info.selfSign && info.selfSign !=1 && info.signStatus == 0);
      //* 2.登陆主体为企业主账户，在查看合同时 企业主账户发起的合同 签署方不包含自己及企业成员时 不显示审批详情入口
      // allAuthUser.accountInfoVO 登陆主体 userType 0 个人 userType 1 企业
      const accType = accInfo && accInfo.userType && accInfo.userType == 1
      //  企业主账户发起的合同
      const priAcc= accType && info && (!info.corpUserId && info.ebqUserId) && (info.ebqUserId === accInfo.userId) // (主账号发起)
      // 签署方不包含自己及企业成员时
      const notHaveMineOrCorp =accType && info && info.signInfos && info.signInfos.filter(
        item => ((item.emailMask && accInfo.emailMask) && (item.emailMask !== accInfo.emailMask)) || (item.corpId && (item.corpId !== accInfo.userId))
        ).length == 0
      const notShowAcc = priAcc && notHaveMineOrCorp
     //* 3.登陆主体为企业主账户，在查看合同时 企业主账户发起/签署的合同 签署方包含企业成员时 若有审批流程（用印审批）
      // 则显示审批详情入口 并显示审批流程记录  若无审批流程 则不显示审批详情入口
      //* 4.登陆主体为企业成员账户（个人），在查看合同时 成员账户发起/签署的合同 若存在审批流程（文件审批&用印审批）
      //  *  即显示审批详情入口 若不存在审批流程则不显示审批详情入口
      // * 5.登陆主体为企业成员账户（个人），在查看合同时 成员账户有权限查看的 其他成员的合同
      //  *  若存在审批流程（文件审批&用印审批） 即显示审批详情入口 若不存在审批流程则不显示审批详情入口
      // ! 能查看合同，说明一定有权限
      // 345结论相同不做判断条件，结论同show
      const show = auditDetailInfo &&
                Object.keys(auditDetailInfo).length &&
                (auditDetailInfo.fileFlow.length ||
                  auditDetailInfo.sealFlow.length)
      return !notShowPer && !notShowAcc && show
    },
    getEnclosureImgList() {
      return this.enclosureList.filter(item => {
        return this.isImg(item) || this.isVideo(item);
      });
    },
    // 签署状态
    statusText() {
      switch (this.detailInfo.signStatus) {
        case 0:
          return "未完成";
          break;
        case 1:
          return "已完成";
          break;
        case 2:
          return "已拒绝";
          break;
        default:
          return "未完成";
          break;
      }
    }
  },
  methods: {
    imgShowFn(i) {
      let url = convertDetailToShow({
        docHash: this.contractInfoTemporary.docHash,
        ts: this.contractInfoTemporary.ts,
        sign: this.contractInfoTemporary.sign,
        items: this.contractInfoTemporary.items,
        targetId: this.contractInfoTemporary.targetId,
        fileType: 3,
        fix: "png",
        num: i - 1
      })
      return url;
    },
    /*903需求新增*/
    // 跳转签署日志
    toSignLog: function() {
      let param = {
        signNo: this.signUrl.signNo,
        applyNo: this.signUrl.applyNo,
        sign: this.signTsSignNo.sign,
        ts: this.signTsSignNo.ts
      };

      let { href } = this.$router.resolve({
        path: "/applySign/toSignlog",
        query: param
      });
      window.open(href, "_blank");
    },
    loadingStart() {
      this.loadingClose();
      this.loading = this.$loading({
        lock: true
      });
    },
    loadingClose() {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    closeTabBox() {
      this.tabIndex = 0;
      this.tabActive = 0;
      this.drawerShow = false;
    },
    // 切换展示不同的信息
    tabHandleClick(i) {
      if (this.tabActive === i) {
        this.closeTabBox();
      } else {
        this.tabIndex = i;
        this.tabActive = i;
        if (i === 3) {
          this.clickHanldeAuditDetail();
        }
        this.drawerShow = true;
      }
      this.fileImgShow = this.drawerShow ? false : true;
    },
    // 切换文件展示合同
    chooseFile(file, i) {
      if (this.checkAct === i) return;
      this.contractList = {};
      this.initPage = 0;
      this.convertContractToInfo(file);
      this.checkAct = i;
    },
    // 存储文件的合同文件转换，非上传的临时文件转换
    convertContractToInfo(param) {
      this.loadingStart("正在加载合同信息");
      tempConvertToContract(param)
        .then(({ data }) => {
          this.loadingClose();
          this.contractInfoTemporary = {
            docHash: data.docHash,
            ts: param.ts,
            sign: param.sign,
            items: parseInt(data.items),
            targetId: param.targetId,
            fileId: param.fileId
          };
          this.fileImgName = param.fileName;
          this.getContractDetailByNum(1);
        })
        .catch(err => {
          this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        });
    },
    // 获取文件后缀
    fileSuffix(fileName) {
      let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let namelength = fileName.length; //取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      return filesuffix;
    },
    /**
     *获取附件
     */
    getEnclosure() {
      let query = this.$route.query;
      postFindAttatchInfo(query)
        .then(data => {
          if (data.data) {
            this.enclosureList = data.data;
          }
        })
        .catch(err => {
          console.error("合同信息：" + JSON.stringify(err));
        });
    },
    // 获取附件后缀
    getEnclosureSuffix(item) {
      if (item && item.file && item.file.fileName) {
        let arr = item.file.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件是否是图片
    isImg(item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      let arr = ["PNG", "GIF", "JPG", "JPEG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否是视频
    isVideo(item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['MP4','RMVB','MKV','AVI']
      let arr = ["MP4", "WEBM", "OGG"];
      // let arr = ['MP4']
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否文档
    isDoc(item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 预览图片或者视频
    previewVideOrImg(item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 预览文档
    previewDoc(item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosureDoc = true;
    },
    // 附件下载
    downloadAttatchFile(param) {
      if (!param || param === "null" || param === "false")
        return "javascript:void(0)";
      if (param.fileName === "blob") {
        param.fileName = "attachment.png";
        param.fix = ".png";
      }
      return getFindFileDownload(param);
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData(data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData(data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed(page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    toCurrentPage(val) {
      let dom = document.querySelectorAll(".list-pages .listDetail")[val - 1];
      if (dom) {
        let dom2 = document.querySelectorAll(".list-pages")[0];
        dom2.scrollTop = dom.offsetTop - 20;
      }
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    // 按页数获取合同
    getContractDetailByNum(num) {
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }
      this.currentInfo = {
        page: num,
        url: convertDetailToShow({
          docHash: this.contractInfoTemporary.docHash,
          ts: this.contractInfoTemporary.ts,
          sign: this.contractInfoTemporary.sign,
          items: this.contractInfoTemporary.items,
          targetId: this.contractInfoTemporary.targetId,
          fileType: 3,
          fix: "png",
          num: num - 1
        })
      };
      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },
    //*903 需求完*/
    // 审批详情按钮
    clickHanldeAuditDetail() {
      console.log("this.$route.query",this.$route.query);
      let { signNo, applyNo } = this.$route.query;
      if (!signNo && !applyNo) return false;
      let params = {
        signNo: signNo ? signNo : "",
        applyNo: applyNo ? applyNo : ""
      };
      // params.approveId = query.approveId;
      this.loadingStart();
      ApiCorpMethods.CorpAuditContractController.flowInstV2(params)
        .then(res => {
          this.loadingClose();
          if (res.success && res.code === "0") {
            if(isInDingTalk){this.dingtalkFlowInfo()}
            if(!isInDingTalk) this.auditDetailInfo = res.data;
          } else {
            this.auditDetailInfo = unll;
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.loadingClose();
          this.auditDetailInfo = unll;
          this.$message.error(error.description || "获取审批人列表失败");
        });
    },
    /** 钉钉审批详情 */
    dingtalkFlowInfo(){
      // 查询钉钉审批详情流程
      const { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo")),
      { signNo, applyNo } = this.$route.query,
      _this = this;
      const _applyNo= applyNo ? applyNo : this.detailInfo.applyNo
      const data = { corpId, dingTalkUserId,applyNo: _applyNo }
        dingtalkApi.v2TaskList(data).then(res=>{
        if(!res.success) return isInDingTalk ? false :  this.$message.error(`文件审批详情：${res.description}`)
          _this.auditDetailInfo = {
          fileFlow:[res.data],
          sealFlow:[]
        }
        })
    },
    /** 跳转钉钉oa审批 */
    dingApproval(){
      const { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo")),
        { applyNo } = this.$route.query, _this = this;
      const param = { corpId, dingTalkUserId, applyNo }
      _this.loadingStart()
      dingtalkApi.workflowContract(param).then(res=>{
        if(!res.success) return _this.$message.error(res.description)
        /** 钉钉弹窗逻辑 */
        _this.DINGSDK && _this.DINGSDK.biz.util.openSlidePanel({
            url: res.data, //打开侧边栏的url
            title: '审批', //侧边栏顶部标题
            onSuccess: function (result) { },
            onFail: function () { }
          }).catch((err) => { console.log('跳转钉钉oa审批-catch_err：', err); })
      }).finally(() => { _this.loadingClose() })
    },
    // 审批拒绝
    clickHanldeAuditRefuse(type) {
      this.refuseModel.flowStatus = type;
      if (type === 2 && this.refuseModel.reason === '') {
        return this.$message.error("请输入审批意见")
      }
      this.$confirm(`是否${['', '同意', '拒绝'][type]}审批？`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let str = type === 1
          this.executeAudit(str)
        })
        .catch(() => { });
    },
    // 拒绝原因改变事件
    handleChange() {
      this.refuseModel.wordNumber = this.refuseModel.reason.length;
    },
    // 拒绝原因失去焦点事件
    handleBlur() {
      let v = this.refuseModel.reason;
      if (v) {
        if (v.length > 100) {
          this.refuseModel.errorMessage = "不能超过100个字";
        } else {
          this.refuseModel.errorMessage = "";
        }
      } else {
        this.refuseModel.errorMessage = "请输入审批意见";
      }
    },
    // 提交审核结果
    executeAudit(v) {
      let params = {};
      let { query } = this.$route;
      params.approveId = query.approveId;
      if (v) {
        params.flowStatus = 1;
      } else {
        params.flowStatus = 2;
      }
      params.reason = this.refuseModel.reason;
      console.log("")
      // console.info(params)
      ApiCorpMethods.CorpAuditContractController.approveFlow(params)
        .then(res => {
          if (res.code === "0") {
            if (window.opener) {
              window.opener.location.reload();
            }
            window.close();
          } else {
            this.$message.error(res.description || "审批驳回");
          }
        })
        .catch(error => {
          this.$message.error(error.description || "审批驳回");
        });
    },

    // 输入input合同跳页
    handleContractPageClick(page) {
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.convertInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.currentData = parseFloat(page);
    },

    loadData: function() {
      var _this = this;
      ApiMethods.ApplySignController.infoMulti(_this.viewInfo).then(result => {
        if (!result.success) {
          return _this.$message.error(result.description || "初始化数据失败2");
        }
        _this.detailInfo = result.data;
        _this.fileList = result.data.fileInfos;

        // 极简模式
        if (
          (_this.detailInfo && _this.detailInfo.ifHideBottom == 1) ||
          (_this.detailInfo && _this.detailInfo.hideSignAllBtnFlag == 1)
        ) {
          document.querySelector("header.el-header").style.display = "none";
          _this.mainHeight = _this.mainHeight + 60;
        } else {
          document.querySelector("header.el-header").style.display = "block";
        }
        this.convertContractToInfo(result.data.fileInfos[0]);
      });
    },
    fetchData: function() {
      if (this.$route.query.ts && this.$route.query.sign) {
        this.viewInfo = this.$route.query;
        this.loadData();
      } else {
        //没有签名参数
        var param = {
          signNo: this.$route.query.signNo,
          applyNo: this.$route.query.applyNo
        };
        ApiMethods.UserApplySignController.viewUrl(param).then(result => {
          //{"applyNo":"","ts":,"sign":"","signNo":""}
          if (!result.success) {
            return this.$message.error(result.description || "初始化数据失败1");
          }
          this.viewInfo = result.data;
          this.loadData();
        });
      }
    }
  },
  head: {
    title: "文件审批"
  },
  name: "audit",
  layout: "fullpage"
};
</script>

<style lang="less" scoped>
@mg: 0.2rem; // 左右side给中间合同流的间距
.demo-dynamic {
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.sdetails-dialog {
  .sdetails {
    height: 450px;
    overflow-x: hidden;
    margin: -20px -20px -10px;
    padding: 20px 20px 10px;

    .sdetails-item {
      padding: 20px 0;
      border-bottom: 1px solid #e7e7e7;
    }

    b {
      color: #009899;
    }

    h5 {
      margin: 0;
      color: #009899;
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 6px;
    }

    p {
      color: #333;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      word-break: break-all;
    }
  }
}

.aside-right {
  padding: 20px 20px 0px 20px;
  position: relative;

  &.approve-aside {
    padding: 0;
    padding-top: 20px;
    text-align: center;

    .btn {
      width: 80%;
      margin: 0;
      margin-bottom: 10px;
    }
  }

  .btn {
    width: 100%;
    margin-bottom: 20px;
  }
  .bottom-btns {
    width: 100%;
    position: absolute;
    bottom: 0;
    .bottom_textarea {
      padding: 20px 10px;
    }
  }
}

.file-img-btn {
  position: absolute;
  z-index: 102;
  top: 100px;
  left: 2.8rem;
  width: 1.8rem;
  height: 30px;
  background-color: #eb1b1b;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 20px 0 10px;
  color: #ffffff;
  cursor: pointer;
  strong.file-arrow {
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    top: 8px;
    right: 4px;
  }
}
.list-pages::-webkit-scrollbar {
  width: 0;
}
.list-pages {
  /*position: absolute;*/
  z-index: 112;
  /*margin: 0 auto;*/
  padding-top: 0.2rem;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
  color: #323232;
  overflow-y: auto;
  width: 1.6rem;
  height: 7rem;
  /*top: 150px;*/
  /*left: 2.8rem;*/
  background-color: #ffffff;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);

  i.icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.4rem;
    height: 0.4rem;
    background-size: cover;
  }

  span {
    position: absolute;
    bottom: 0px;
    right: 0;
    display: block;
    width: 0.4rem;
    height: 0.3rem;
    line-height: 0.3rem;
    color: #fff;
    background-color: #e3e3e3;
    text-align: center;
    border-radius: 0.06rem 0px 0px 0px;
  }

  img {
    max-height: 3rem !important;
    width: 100%;
    box-sizing: border-box;
    /*margin-bottom: 10px;*/
    border: 0.02rem solid #e3e3e3;
  }

  .listDetail {
    position: relative;
    /*margin: 0 30px 20px 30px;*/
    margin-bottom: 0.2rem;
    cursor: pointer;
  }

  .active {
    img {
      border-color: #ec1c1c;
    }

    span {
      background-color: #ec1c1c;
    }
  }
}
.main-box {
  display: table-cell;
  padding: 0;
  background: #eee;
  text-align: center;
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
}

.contract-bottom {
  position: absolute;
  bottom: 60px;
  right: 20px;
  width: 50px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 100;

  span {
    width: 50px;
    height: 50px;
    font-size: 24px;
    color: #eeeeee;
    font-weight: bold;
    text-align: center;
    line-height: 50px;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 3px 0;
    z-index: 4;
    opacity: 0.8;
    cursor: pointer;

    img {
      width: 20px;
      height: auto;
      vertical-align: middle;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.6);
      opacity: 1;
    }
  }

  span.arrow-down {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  span.arrow-up {
    transform: rotate(180deg);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.aside-left {
  box-sizing: border-box;
  background-color: #ffffff;
  margin-right: @mg;
  overflow-y: auto;
  position: relative;
  z-index: 103;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);

  .cred {
    color: #ec1c1c;
  }

  .list {
    position: relative;
    cursor: pointer;
    width: 1.4rem;
    height: 130px;
    margin: 0.2rem auto;
    border-radius: 4px;
    overflow: hidden;
    border: 0.02rem solid #e5e5e5;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);

    .bx {
      width: 100%;
      height: 70px;
      text-align: center;
      line-height: 70px;
      position: relative;

      img {
        height: 38px;
        width: auto;
      }

      .read-status {
        width: 36px;
        height: 22px;
        position: absolute;
        right: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.25);
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
      }
    }

    p.title {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      padding: 0 10px;
      text-align: center;
      height: 45px;
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #290202;
      line-height: 23px;
    }
  }

  .list.active {
    border-color: #ec1c1c;
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    border-bottom: 1px solid #f2f2f2;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    box-sizing: border-box;

    .tit {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .aside-left_flex {
    display: flex;
    justify-content: space-between;
    padding-left: 0.1rem;
  }
  .page-con {
    overflow-y: auto;
    /*position: absolute;*/
    /*width: 100%;*/
    /*left: 0;*/
    /*bottom: 0.1rem;*/
    /*top: 60px;*/
  }

  .sec-content {
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    z-index: 2;
    padding: 0 0.15rem;

    .content {
      color: #bcbcbc;
      margin-bottom: 0.16rem;
      word-break: break-word;
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;
    }

    .text-ellipsis {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .title {
      /*margin-bottom: 5px;*/
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
    }

    .nav-item {
      padding-top: 0.15rem;
      border-bottom: 1px solid #e4e4e4;
    }

    .wnj {
      .title {
        color: rgba(0, 0, 0, 0.45);
      }

      .content {
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }

  .aside-bar {
    border-bottom: 1px solid #e4e4e4;
    text-align: center;

    li {
      display: inline-block;
      box-sizing: border-box;
      padding: 0.06rem;
      min-width: 0.72rem;
      background: #fff;
      border-top-left-radius: 0.04rem;
      border-top-right-radius: 0.04rem;
      border: 1px solid #e4e4e4;
      border-bottom: 0;
      font-size: 0.12rem;
      cursor: pointer;
      text-align: center;
      color: #666666;
    }

    li.active {
      color: #fff;
      background-color: #999999;
      border-color: #999999;
    }
  }

  .page-input {
    padding: 0.1rem 0.15rem 0.2rem 0.15rem;

    .btn {
      padding: 0;
      width: 0.5rem;
      // color: #333333;
      margin: 0 -0.16rem;
    }
  }
}
/*进入前和结束后的状态*/
.my-enter,
.my-leave-to {
  opacity: 0;
  width: 0;
}

/*进入和离开的动画时间段*/
.fade-enter-active,
.fade-leave-active {
  transition: all 2s ease;
}

.aside {
  position: absolute;
  top: 60px;
  width: calc(100% - 2.8rem);
  z-index: 100;
  left: 2.8rem;
  background-color: rgba(0, 0, 0, 0.6);
}

.aside-tab {
  width: 32px;
  height: auto;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  box-sizing: border-box;
  transform: translateY(-50%);
  z-index: 102;

  .tab {
    color: #eb090a;
    width: 32px;
    height: 135px;
    writing-mode: vertical-lr;
    font-size: 12px;
    /*color: #a1a1a1;*/
    background-color: #fff;
    border-radius: 0 10px 10px 0;
    display: flex;
    margin: 5px 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);

    .word {
      margin: 5px 0;
    }
  }

  .tab.active {
    color: #eb090a;
  }
  .tab.black {
    color: #000000;
  }
}

.aside-tab.open {
  left: calc(800px + 3.2rem);
}

.aside-tab.close {
  left: 3.1rem;
  z-index: 103;
}

.aside-content {
  position: absolute;
  top: 60px;
  left: 3.2rem;
  width: 800px;
  height: 100%;
  box-sizing: border-box;
  background-color: #eeeeee;
  z-index: 103;

  .aside-top {
    width: 100%;
    height: 60px;
    background-color: #f8f8f8;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    align-items: center;
    font-size: 12px;
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/

    .el-icon-error {
      font-size: 20px;
      cursor: pointer;
      color: #646464;
    }
  }

  /*.aside-tab{
      width: 32px;
      height: auto;
      display: flex;
      flex-direction: column;
      position: absolute;
      right: -32px;
      top: 50%;
      transform: translateY(-50%);
      .tab{
        width: 32px;
        height: 135px;
        writing-mode: vertical-lr;
        font-size: 12px;
        color: #A1A1A1;
        background-color: #fff;
        border-radius: 0 10px 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .tab.active{
        color: #eb090a;
      }
    }*/

  .aside-box {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    position: absolute;
    overflow-y: auto;
    height: 100%;

    .enclosure-box {
      display: flex;
      flex-wrap: wrap;

      .enclosure-item {
        width: 110px;
        height: 110px;
        margin: 10px;
        position: relative;

        &:hover {
          .li-preview {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .li-preview {
          cursor: default;
          font-weight: bold;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.7);
          opacity: 0;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all ease-in 0.2s;
          z-index: 3;
          color: #ffffff;
          font-size: 18px;

          span {
            color: #ffffff;
            margin-top: -20px;
            display: inline-block;
            cursor: pointer;
            font-weight: bold;
            margin-right: 20px;

            &:last-child {
              margin-right: 0;
            }
          }

          a {
            margin-top: -20px;
            display: inline-block;
          }

          img {
            width: 100%;
            height: auto;
          }
        }

        .li-con {
          box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);
          line-height: 90px;
          text-align: center;
          /*position: relative;*/
          width: 100%;
          height: 100%;
          overflow: hidden;

          img {
            max-width: 100%;
            max-height: 100%;
          }

          h1 {
            cursor: default;
            z-index: 4;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0, 0, 0, 1);
            height: 20px;
            text-align: center;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: rgba(255, 255, 255, 1);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            opacity: 0.7;
            box-sizing: border-box;
            padding: 0 5px;
          }

          .t-do {
            line-height: initial;
            padding-top: 30px;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            color: #646464;
            font-weight: bold;
            font-size: 20px;
            font-family: PingFang SC;
            text-align: center;
            background: url("../../assets/images/bg-repeat.png") repeat;
            background-size: contain;
          }
        }
      }
    }

    .signingFlow-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: auto;
      .signingFlow-top {
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        a {
          color: rgba(236, 28, 28, 1);
          font-size: 12px;
        }
      }
      .signingFlow-tit {
        width: 220px;
        height: 64px;
        background-color: #f8f8f8;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 12px;
        margin-bottom: 10px;

        .photo {
          width: 36px;
          height: 36px;
          background: #ffffff;
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
          border-radius: 50%;
          overflow: hidden;
          margin-right: 16px;
        }

        p {
          width: 140px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          cursor: pointer;
        }
      }

      .arr-down {
        background-color: #290202;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        text-align: center;
        line-height: 20px;
        color: #ffffff;
        font-size: 16px;
        margin: 23px 0;
        position: relative;

        &:before {
          content: "";
          width: 0;
          border-left: #999999 solid 1px;
          position: absolute;
          top: -20px;
          left: 50%;
          /*transform: scaleX(0.5);*/
          height: 20px;
        }

        &:after {
          content: "";
          width: 0;
          border-left: #999999 solid 1px;
          position: absolute;
          bottom: -20px;
          left: 50%;
          /*transform: scaleX(0.5);*/
          height: 20px;
        }
      }
      .signStatus {
        text-align: center;
        border: 1px solid #ec7e1c;
        border-radius: 2px;
        line-height: 1;
        vertical-align: middle;
        padding: 2px 5px;
        display: inline-block;
        margin-bottom: 10px;
        font-size: 14px;
      }
      .signStatus.s0 {
        border: 1px solid #ec7e1c;
        color: #ec7e1c;
      }
      .signStatus.s-3 {
        border: 1px solid #ec7e1c;
        color: #ec7e1c;
      }
      .signStatus.s1 {
        border: 1px solid #009899;
        color: #009899;
      }
      .signStatus.s2 {
        border: 1px solid #ec1c1c;
        color: #ec1c1c;
      }
    }

    .signingFlow {
      width: 688px;
      border: 1px solid #e5e5e5;
      box-sizing: border-box;
      padding: 15px;
      position: relative;
      background-color: #ffffff;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.04);

      .signingFlow-item {
        width: 144px;
        height: 90px;
        float: left;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        margin: 15px 10px;
        box-sizing: border-box;
        position: relative;

        .signing-flow-tit {
          width: 144px;
          height: 64px;
          background-color: #f8f8f8;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding: 5px;

          .photo {
            width: 36px;
            height: 36px;
            background: #ffffff;
            box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
            border-radius: 50%;
            overflow: hidden;
            margin-right: 10px;
          }

          p {
            width: 84px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            cursor: pointer;
          }
        }
      }

      .orderLi {
        &:before {
          width: 16px;
          height: 16px;
          position: absolute;
          font-size: 14px;
          background-color: #888888;
          color: #ffff;
          border-radius: 50%;
          text-align: center;
          line-height: 16px;
          font-family: element-icons !important;
        }

        &:nth-child(2) {
          &:before {
            content: "\e6e9";
            left: -18px;
            top: 22px;
          }
        }

        &:nth-child(3) {
          &:before {
            content: "\e6e9";
            left: -18px;
            top: 22px;
          }
        }

        &:nth-child(4) {
          &:before {
            content: "\e6e9";
            left: -18px;
            top: 22px;
          }
        }

        &:nth-child(5) {
          float: right;
          &:before {
            content: "\e6eb";
            left: 64px;
            top: -20px;
          }
        }

        &:nth-child(6) {
          float: right;
          &:before {
            content: "\e6ea";
            right: -18px;
            top: 22px;
          }
        }

        &:nth-child(7) {
          float: right;

          &:before {
            content: "\e6ea";
            right: -18px;
            top: 22px;
          }
        }

        &:nth-child(8) {
          float: right;

          &:before {
            content: "\e6ea";
            right: -18px;
            top: 22px;
          }
        }

        &:nth-child(9) {
          float: left;

          &:before {
            content: "\e6eb";
            left: 64px;
            top: -20px;
          }
        }

        &:nth-child(10) {
          float: left;

          &:before {
            content: "\e6e9";
            left: -18px;
            top: 22px;
          }
        }
      }
    }
  }
}

.audit-style {
  margin: -20px;
}
</style>



// WEBPACK FOOTER //
// pages/applySign/auditMulti.vue